import Header from 'modules/header/wholesaler/main';
import Roles from 'modules/acount/roles';

const RolesPage = () => {
  return (
    <>
      <Header title="قوانین و مقررات" />
      <Roles app="market" />
    </>
  );
};

export default RolesPage;
